import { Link } from "react-router-dom";
import { Lock, ArrowRight } from "lucide-react";

// CYANNECT-PRICING-FINAL · shown when the backend answers 403 plan_upgrade_required for a Basic merchant.
export function isPlanUpgradeError(err) {
  return err?.response?.status === 403 && err?.response?.data?.detail?.error === "plan_upgrade_required";
}

export function PlanUpgradeNotice({ detail, title = "Part of Starter and Pro", testid = "plan-upgrade-notice" }) {
  return (
    <div className="max-w-2xl mx-auto p-8 rounded-2xl bg-gradient-to-br from-slate-50 to-cyan-50 border border-slate-200 text-center"
         data-testid={testid}>
      <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-white border border-cyan-200 mb-4">
        <Lock className="w-5 h-5 text-cyan-600" />
      </div>
      <h2 className="font-display text-2xl text-slate-900">{title}</h2>
      <p className="text-sm text-slate-600 mt-2 max-w-md mx-auto" data-testid={`${testid}-message`}>{detail?.message}</p>
      <div className="mt-5 flex items-center justify-center gap-3">
        <Link to="/merchant/billing" data-testid={`${testid}-cta`}
              className="pf-btn-primary px-5 py-2.5 rounded-full text-sm font-semibold inline-flex items-center gap-2">
          Change plan <ArrowRight className="w-4 h-4" />
        </Link>
        <Link to="/merchant/analytics" data-testid={`${testid}-headline-link`}
              className="text-xs font-semibold text-slate-600 hover:text-slate-900 underline">
          See my 30-day totals
        </Link>
      </div>
    </div>
  );
}
